<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' class="m-b-20" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="提交人" name='keyword'>
        <a-input v-model:value="search.keyword" style="width:250px" placeholder="请输入名称/手机号" />
      </a-form-item>
      <a-form-item label="提交任务" name='group_task_id'>
        <a-input v-model:value="search.group_task_id" style="width:250px" placeholder="请输入任务ID" />
      </a-form-item>
      <a-form-item label="门店名称" name='apply_name'>
        <a-input placeholder="请输入门店名称" style="width: 200px;" readonly v-model:value="search.apply_name"></a-input>
        <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 13px;" v-if='search.apply_name' @click='search.apply_name="";' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="showStore=true">选择</a-button>
      </a-form-item>
      <a-form-item label="状态" name='examine_status'>
        <a-select v-model:value="search.examine_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="0">待处理</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="2">已拒绝</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="提交时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" ghost v-has:exaExport="exportTable">导出</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class='tableFixBox' :scroll="{ x: 'max-content'}">
      <template v-slot:action="{ record }">
        <a-button type="link" size="small" v-has:GroupPurchaseAdd="()=>{$router.push('/guide/GroupPurchase/components/applicationDetails?type=store&id='+record.id)}">详情</a-button>
        <a-button  v-if="record.examine_status!=0" type="link" size="small" v-has:delapplicationDetails="()=>delappDet(record)">删除</a-button>
      </template>
            <template v-slot:group_task_id="{ record }">
        <a @click="handeleclick(record)">{{record.group_task_id}}</a>
      </template>
         <template v-slot:submit_name="{ record }">
        <p>{{record.submit_name}}</p>
        <p>({{record.submit_phone}})</p>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1200' destroyOnClose :footer="null">
     <selectStore :checkout='false' v-on:select="storeSelect" :selectList='[{id:search.store_id}]' :hiddenHead='true'></selectStore>
  </a-modal>
    <a-modal title="任务详情" v-model:visible="detatilvisible" centered :width='1200' destroyOnClose :footer="null">
      <taskdetatil :task_id='task_id' :task_type='task_type'></taskdetatil>
    </a-modal>
</template>
<script>
import { CloseCircleFilled } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getexamineList, delexamine } from "@/api/guide";
import { iscode } from "@/utils/app";
import { qrcanvas } from "qrcanvas";
import taskdetatil from "../group_create.vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  apply_type: 2,
  keyword: "",
  apply_name: "",
  examine_status: "",
  dealer_id: "",
  group_task_id: "",
  send_status: "",
  start_time: "",
  end_time: "",
  is_awards: "",
  store_id:'',
};
export default {
  components: {
    CloseCircleFilled,
    taskdetatil
  },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const $route = inject("$route");
    const state = reactive({
      showStore: false,
      questionnaire_id: "",
      listLoading: false,
      total: 0,
       task_id:'',
      task_type:'',
      detatilvisible:false,
    });
    let columns = [
      {
        title: "提交人",
        dataIndex: "submit_name",
        key: "submit_name",
        slots: { customRender: "submit_name" },

      },
      {
        title: "门店名称",
        dataIndex: "apply_name",
        key: "apply_name",
        customRender: ({ record }) => {
          return record.apply_name ? record.apply_name : "-";
        },
      },
      {
        title: "状态",
        dataIndex: "examine_status_text",
        key: "examine_status_text",
      },
      {
        title: "提交任务（ID）",
        dataIndex: "group_task_id",
        key: "group_task_id",
             slots: { customRender: "group_task_id" },
      },
           {
        title: "提交时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
      const handeleclick =  (e) => {
  state.detatilvisible=true;
   state.task_id=e.group_task_id
   state.task_type='look'
   console.log(state.task_id);
    }
    //删除
    const delappDet = async (e) => {
      $Modal.confirm({
        title: "提示",
        content: "删除后不可恢复，确定删除吗？",
        centered: true,
        onOk: async () => {
          let res = await delexamine({ id: e.id })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res)) {
            message.success(res.message);
            initData();
          } else {
            message.error(res.message);
          }
        },
      });
    };
    const onChangeTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData();
    };
    //选择门店
    const storeSelect = (data) => {
      search.value.apply_name = data.store_name;
      search.value.store_id = data.id;
      state.showStore = false;
    };
    const initData = async () => {
      state.listLoading = true;
      let res = await getexamineList({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.message);
      }
    };
    // 导出
    const exportTable = async () => {
      let res = await getexamineList({
        ...search.value,
        excel: 1,
      }).then((res) => res.data);
      if (iscode(res)) {
        window.open(res.data.url);
      } else {
        message.error(res.message);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
      storeSelect,
      delappDet,
      onChangeTime,
      exportTable,
      handeleclick
    };
  },
};
</script>
<style>
.ant-table td {
  white-space: nowrap;
}
</style>